// imports
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../..';
import { QuestCost } from '../../../../common/types';
import {
  claimRewards as claimRewardsThunk,
  setQuestTimer as setQuestTimerThunk
} from '../../thunks';

// redux slice
const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    map: {
      currRegion: {
        id: '',
        scale: 0,
        position: []
      }
    },
    prompt: {
      bio: false,
      notification: false,
      reward: { awarded: [], questId: '' } as { awarded: QuestCost[]; questId: string }
    },
    questsProgress: {} as { [key: string]: { time: string; progress: number } }
  },
  reducers: {
    setBioPrompt: (state, action) => { state.prompt.bio = action.payload; },
    setMapRegion: (state, action) => { state.map.currRegion = action.payload; },
    resetRewardPrompt: (state) => { state.prompt.reward = { questId: '', awarded: [] }; },
    setNotificationPrompt: (state, action) => { state.prompt.notification = action.payload; }
  },
  extraReducers: (builder) => {
    // quests - progress update
    builder.addCase(setQuestTimerThunk.fulfilled, (state, action) => {
      const { id, time, progress } = action.payload as { id: string; time: string; progress: number };
      if (time === '0s') {
        delete state.questsProgress[id];
      } else {
        state.questsProgress[id] = { time, progress };
      }
    });
    // quests - claim
    builder.addCase(claimRewardsThunk.fulfilled, (state, action) => {
      const { questId } = action.meta.arg;
      const rewards = action.payload as QuestCost[];
      const filteredRewards = rewards.filter((reward) => reward.amount);
      state.prompt.reward = { questId, awarded: filteredRewards };
    });
  }
});

// exports
export const {
  setBioPrompt, setMapRegion,
  setNotificationPrompt, resetRewardPrompt
} = uiSlice.actions;
export const selectUIMap = (state: RootState): typeof state.ui.map => state.ui.map;
export const selectUIPrompt = (state: RootState): typeof state.ui.prompt => state.ui.prompt;
export const selectUIQuestProgress = (state: RootState): typeof state.ui.questsProgress => state.ui.questsProgress;
export default uiSlice.reducer;
